export default class StorageUtils {
  static getItem(key) {
    return localStorage.getItem(key);
  }

  static getObjectItem(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  static setItem(key, value) {
    return localStorage.setItem(key, value);
  }

  static setObjectItem(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
  }

  static removeItem(key) {
    return localStorage.removeItem(key);
  }

  /** Retry getObjectItem until the value defined (or timeout). Hacky way to resolve race conditions */
  static async getObjectItemWithRetry(
    key,
    { interval = 100, timeout = 5000 } = {},
  ) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const check = () => {
        const value = StorageUtils.getObjectItem(key);
        if (value != null) {
          resolve(value);
          return;
        }
        if (Date.now() - start >= timeout) {
          reject(new Error("StorageUtils couldn't fetch " + key));
          return;
        }
        setTimeout(check, interval);
      };

      check();
    });
  }
}
